import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { mutate } from 'swr'
import { createSeries } from '../services/vodApi'
import { Banner, Button } from '../components'
import pageStyles from '../styles/page.module.scss'
import formStyles from '../styles/forms.module.scss'

const SeriesCreate: React.FC = () => {
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async () => {
    if (!title.trim()) return
    setError(null)
    setSaving(true)
    try {
      const created = await createSeries({ title: title.trim(), description: description.trim() || null })
      // The detail page reads the shared series list, so refresh it before arriving.
      await mutate('vod-series')
      navigate(`/series/${created.tc_series_id}`)
    } catch (err) {
      setError(`Failed to create series: ${(err as Error).message}`)
      setSaving(false)
    }
  }

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>New Series</h1>
        <p>Add seasons from the series page once it is created.</p>
      </div>

      {error && <Banner variant="error" message={error} onDismiss={() => setError(null)} autoScroll />}

      <div className={formStyles.formContainer}>
        <div className={formStyles.formSection}>
          <h3>Title</h3>
          <div className={formStyles.formField}>
            <input
              id="new-series-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              disabled={saving}
              autoFocus
            />
          </div>
        </div>

        <div className={formStyles.formSection}>
          <h3>Description</h3>
          <div className={formStyles.formField}>
            <textarea
              id="new-series-description"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={saving}
            />
          </div>
        </div>

        <div className={formStyles.formFooter}>
          <Button variant="secondary" onClick={() => navigate('/series')} disabled={saving}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!title.trim() || saving}>
            {saving ? 'Creating...' : 'Create Series'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SeriesCreate
